import Vue from 'vue'

import App from './App.vue'
import router from './router'

import BootstrapVue from 'bootstrap-vue'

import '@/plugins/moment'
import '@/plugins/numeral'
import i18n from '@/plugins/vueI18n'
import vuetify from '@/plugins/vuetify'
import NsLanguage from '@/plugins/ns-language'
import FeatureFlagPlugin from '@nuskin/ns-feature-flags-vue'

import '@dev'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(NsLanguage)

const host = window && window.location && window.location.host ? window.location.host : ''
let unleashedHost = 'https://api.cloud.nuskin.com/'

if (host.indexOf('aem-1.dev.usw2.nuskin.io') !== -1) {
    unleashedHost = 'https://devapi.cloud.nuskin.com/feature-flags/v1/proxy'
} else if (host === 'apps.dev.nuskin.io') {
    unleashedHost = 'https://devapi.cloud.nuskin.com/feature-flags/v1/proxy'
} else if (host === 'dev.nuskin.com') {
    unleashedHost = 'https://devapi.cloud.nuskin.com/feature-flags/v1/proxy'
} else if (host === 'test.nuskin.com') {
    unleashedHost = 'https://testapi.cloud.nuskin.com/feature-flags/v1/proxy'
} else {
    unleashedHost = 'https://api.cloud.nuskin.com/feature-flags/v1/proxy'
}

Vue.use(FeatureFlagPlugin, { url: unleashedHost })

i18n.locale = 'en_US'

new Vue({
    i18n,
    router,
    vuetify,
    beforeCreate () {
        this.$nsLanguage.setI18n(this.$i18n)
    },
    render: h => h(App)
}).$mount('#app')
